import {
  typography as fableticsTypography,
  baseFontSize as fableticsBaseFontSize,
} from '../fabletics/typography';

/* syncing up Yitty's fonts to match Fabletics's, do not customize these */
export const typography = {
  ...fableticsTypography,
};

export const baseFontSize = fableticsBaseFontSize;
